import React from "react";
import { LoginLayout } from "./LoginLayout";
import { Link } from "react-router-dom";
import { RegisterForm } from "./fragments/RegisterForm";

export default function RegisterContainer() {
  return (
    <LoginLayout>
      <div className="py-8 w-full">
        <p className="text-2xl font-bold">Sign Up</p>
        <div className="flex flex-col gap-4 my-4 sm:mb-6">
          <p className="text-[#ABABAB]">
            Do you have an account?{" "}
            <Link to="/login" className="text-[var(--color-button-bg)] font-semibold">
              Sign in
            </Link>
          </p>
        </div>
        <RegisterForm />
      </div>
    </LoginLayout>
  );
}
